import React from "react";

import Svg from "../../../../../components/svg/Svg";
import { Info } from "../../../../../components/svg/svgImageList";
import Tooltip from "../../../../../components/tooltip/Tooltip";
import dateService from "../../../../../services/date-service/DateService";
import { translationService } from "../../../../../services/translation/TranslationService";
import "./InfoTooltip.scss";

interface InfoTooltipProps {
  nextBillingDate: Date;
  firstBoldedTextKey: string;
  firstTextKey: string;
  secondBoldedTextKey?: string;
  secondTextKey?: string;
}

export const InfoTooltip = (props: InfoTooltipProps) => {
  const { nextBillingDate, firstBoldedTextKey, firstTextKey, secondBoldedTextKey, secondTextKey } =
    props;

  const tooltipContent = (
    <div className="tooltip-content">
      <span className="bolded-text">{translationService.translate(firstBoldedTextKey)}</span>
      {translationService.translate(firstTextKey, {
        nextPaymentDate: dateService.formatDate(nextBillingDate, "dd MMM yyyy"),
      })}
      {secondBoldedTextKey && (
        <span className="bolded-text">{translationService.translate(secondBoldedTextKey)}</span>
      )}
      {secondTextKey &&
        translationService.translate(secondTextKey, {
          nextPaymentDate: dateService.formatDate(nextBillingDate, "dd MMM yyyy"),
        })}
    </div>
  );

  return (
    <Tooltip title={tooltipContent}>
      <Svg className="info" svg={Info} width={20} height={20} />
    </Tooltip>
  );
};
